import { render, staticRenderFns } from "./OrderSummary.vue?vue&type=template&id=2da4cb9d&scoped=true&"
import script from "./OrderSummary.vue?vue&type=script&lang=js&"
export * from "./OrderSummary.vue?vue&type=script&lang=js&"
import style0 from "./OrderSummary.vue?vue&type=style&index=0&id=2da4cb9d&lang=scss&scoped=true&"
import style1 from "./OrderSummary.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da4cb9d",
  null
  
)

export default component.exports